import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08d5e346"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "TableBox",
  style: {"height":"auto"}
}
const _hoisted_2 = {
  class: "TableTop",
  style: {"margin-bottom":"10px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("筛选")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = { class: "TableTopBtn" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_7 = { style: {"padding":"20px"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("已删除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("查看详情")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_12 = {
  key: 0,
  class: "sortingBox"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("排序")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("已删除")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("新增手册")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_20 = {
  key: 0,
  class: "sortingBox"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("排序")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_AddOrEditDialog = _resolveComponent("AddOrEditDialog")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$globalFun.ifAuth(_ctx.$route, '操作手册-列表'))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_form, {
                model: _ctx.query,
                inline: "",
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "菜单名称：" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.query.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.name) = $event)),
                        placeholder: "请输入菜单名称",
                        size: "small",
                        clearable: "",
                        onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getList('place')))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "small",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getList('place')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        size: "small",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.init()))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.projectStatus !== 1 && _ctx.$globalFun.ifAuth(_ctx.$route, '操作手册-新增'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      size: "small",
                      icon: "plus",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onAddOrEdit()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_vxe_table, {
              border: "",
              data: _ctx.list,
              "row-config": { isCurrent: true, isHover: true },
              loading: _ctx.loading,
              "max-height": "1000",
              "expand-config": { reserve: true },
              "row-id": "id",
              ref: "tableRef"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_column, {
                  type: "expand",
                  title: "#",
                  "show-overflow": "ellipsis",
                  align: "center",
                  width: "60"
                }, {
                  content: _withCtx(({ row, rowIndex }) => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_vxe_table, {
                        border: "",
                        data: row.children,
                        "row-config": { isCurrent: true, isHover: true },
                        "row-id": "id"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_vxe_column, {
                            field: "name",
                            title: "二级菜单",
                            "show-overflow": "ellipsis",
                            align: "center"
                          }),
                          _createVNode(_component_vxe_column, {
                            field: "iteration_name",
                            title: "迭代版本",
                            "show-overflow": "ellipsis",
                            align: "center"
                          }),
                          _createVNode(_component_vxe_column, {
                            field: "created_at",
                            title: "创建时间",
                            "show-overflow": "ellipsis",
                            align: "center"
                          }),
                          _createVNode(_component_vxe_column, {
                            field: "sort",
                            title: "排序",
                            align: "center",
                            sortable: "",
                            width: "120"
                          }, {
                            default: _withCtx(({ row: itemRow }) => [
                              (row.children.ifSortingItem)
                                ? (_openBlock(), _createBlock(_component_el_input_number, {
                                    key: 0,
                                    modelValue: itemRow.newSorting,
                                    "onUpdate:modelValue": ($event: any) => ((itemRow.newSorting) = $event),
                                    min: 0,
                                    size: "mini",
                                    style: {"width":"100px"}
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(itemRow.sort), 1)
                                  ], 64))
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_vxe_column, {
                            title: "状态",
                            "show-overflow": "ellipsis",
                            align: "center"
                          }, {
                            default: _withCtx(({ row }) => [
                              (row.status === 0)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 0,
                                    type: "info"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_el_switch, {
                                    key: 1,
                                    disabled: !_ctx.$globalFun.ifAuth(_ctx.$route, '操作手册-显示/隐藏'),
                                    modelValue: row.status,
                                    "onUpdate:modelValue": ($event: any) => ((row.status) = $event),
                                    "active-value": 1,
                                    "inactive-value": 2,
                                    onChange: ($event: any) => (_ctx.editStatus(row)),
                                    "active-color": "#13ce66",
                                    "inactive-color": "#ff4949"
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"]))
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_vxe_column, {
                            title: "操作",
                            fixed: "right",
                            width: "260",
                            "show-overflow": "ellipsis",
                            align: "center"
                          }, {
                            default: _withCtx(({ row }) => [
                              (_ctx.$globalFun.ifAuth(_ctx.$route, '操作手册-详情'))
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    size: "mini",
                                    onClick: ($event: any) => (_ctx.onEditItem(2, row.id, row.parent_id))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_9
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (_ctx.$globalFun.ifAuth(_ctx.$route, '操作手册-编辑'))
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    type: "primary",
                                    size: "mini",
                                    onClick: ($event: any) => (_ctx.onEditItem(1, row.id, row.parent_id))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_10
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (_ctx.$globalFun.ifAuth(_ctx.$route, '操作手册-删除'))
                                ? (_openBlock(), _createBlock(_component_el_button, {
                                    key: 2,
                                    type: "danger",
                                    size: "mini",
                                    onClick: ($event: any) => (_ctx.onDel(row.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["data"]),
                      (row.children.length > 0 && _ctx.$globalFun.ifAuth(_ctx.$route, '操作手册-排序'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (!row.children.ifSortingItem)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "primary",
                                  size: "small",
                                  onClick: ($event: any) => (_ctx.onSortingItemShow(rowIndex))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_13
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "small",
                                    onClick: ($event: any) => (_ctx.onSortingItemSave(rowIndex))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_14
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_el_button, {
                                    type: "danger",
                                    size: "small",
                                    onClick: ($event: any) => (row.children.ifSortingItem = false)
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_15
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ], 64))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "name",
                  title: "一级菜单",
                  "show-overflow": "ellipsis",
                  align: "center"
                }),
                _createVNode(_component_vxe_column, {
                  field: "created_at",
                  title: "创建时间",
                  "show-overflow": "ellipsis",
                  align: "center"
                }),
                _createVNode(_component_vxe_column, {
                  field: "sort",
                  title: "排序",
                  align: "center",
                  sortable: "",
                  width: "120"
                }, {
                  default: _withCtx(({ row }) => [
                    (_ctx.ifSorting)
                      ? (_openBlock(), _createBlock(_component_el_input_number, {
                          key: 0,
                          modelValue: row.newSorting,
                          "onUpdate:modelValue": ($event: any) => ((row.newSorting) = $event),
                          min: 0,
                          size: "mini",
                          style: {"width":"100px"}
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(row.sort), 1)
                        ], 64))
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "status",
                  title: "状态",
                  "show-overflow": "ellipsis",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    (row.status === 0)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "info"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_switch, {
                          key: 1,
                          disabled: !_ctx.$globalFun.ifAuth(_ctx.$route, '操作手册-显示/隐藏'),
                          modelValue: row.status,
                          "onUpdate:modelValue": ($event: any) => ((row.status) = $event),
                          "active-value": 1,
                          "inactive-value": 2,
                          onChange: ($event: any) => (_ctx.editStatus(row)),
                          "active-color": "#13ce66",
                          "inactive-color": "#ff4949"
                        }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  title: "操作",
                  fixed: "right",
                  width: "260",
                  "show-overflow": "ellipsis",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    (_ctx.$globalFun.ifAuth(_ctx.$route, '操作手册-新增'))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "warning",
                          size: "mini",
                          onClick: ($event: any) => (_ctx.onEditItem(0, null, row.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.$globalFun.ifAuth(_ctx.$route, '操作手册-编辑'))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          size: "mini",
                          onClick: ($event: any) => (_ctx.onAddOrEdit(row.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.$globalFun.ifAuth(_ctx.$route, '操作手册-删除'))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 2,
                          type: "danger",
                          size: "mini",
                          onClick: ($event: any) => (_ctx.onDel(row.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "loading"]),
            (_ctx.list.length > 0 && _ctx.$globalFun.ifAuth(_ctx.$route, '操作手册-排序'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (!_ctx.ifSorting)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        size: "small",
                        onClick: _ctx.onSortingShow
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "small",
                          onClick: _ctx.onSortingSave
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_button, {
                          type: "danger",
                          size: "small",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.ifSorting = false))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_23
                          ]),
                          _: 1
                        })
                      ], 64))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_AddOrEditDialog, { ref: "addOrEditDialogRef" }, null, 512)
        ], 64))
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "暂无权限"
        }))
  ]))
}